// eslint-disable-next-line complexity
export const formatClusterData = data => data.map(cluster => ({
    ...cluster,
    paceBudget: cluster.paceBudget || 10,
    paceTarget: cluster.paceTarget || 7.1,
    minimumPerformanceValue: cluster.minimumPerformanceValue || null,
    minimumDailyBudgetValue: cluster.minimumDailyBudgetValue || null,
    performanceWindow: cluster.performanceWindow || 7,
    daysBetweenAdjustmentsTarget: cluster.daysBetweenAdjustmentsTarget || 1,
    daysBetweenAdjustmentsBudget: cluster.daysBetweenAdjustmentsBudget || 1,
}));
